<template>
  <l-layout :layout="['xs12']" bottom-space>
    <v-layout justify-center>
      <v-flex xs12>
        <v-card class="pa-3">
          <v-form ref="extraConfigForm">
            <v-layout column>
              <v-layout  class="mb-3">
              <v-flex xs4 class="pl-2">
                <v-autocomplete
                  :items="searchSelects"
                  v-model="ownerId"
                  v-on:keyup="getGroups"
                  label="分组名称"
                  clearable
                  hide-details
                  hide-selected
                  item-text="name"
                  item-value="id"
                  prepend-icon="$vuetify.icons.group"
                  :rule="[$rules.requiredS('必填')]"
                  :disabled = "status==='readonly'"
                >
                  <template slot="no-data">
                    <v-alert :value="true" color="error">
                      暂无该用户组信息
                    </v-alert>
                  </template>
                  <template slot="item" slot-scope="props">
                    <v-list-tile-content>
                      <v-list-tile-title>
                        <v-flex row align-center justify-between>
                          <span>{{props.item.name}}</span>
                        </v-flex>
                      </v-list-tile-title>
                    </v-list-tile-content>
                    <v-list-tile-action>
                      <span class="grey--text caption text-xs-right">{{props.item.code}}</span>
                    </v-list-tile-action>
                  </template>
                </v-autocomplete>
              </v-flex>
              </v-layout>
              <v-layout column v-if="ownerId!==''">
                <v-layout  class="mb-3">
                  <v-flex xs4 class="pl-2">
                    <v-autocomplete
                      :items="extraInfo.groupUserSelect"
                      v-model="extraInfo.driver"
                      v-on:keyup="getGroupUsers"
                      label="公车驾驶员配置"
                      clearable
                      hide-details
                      hide-selected
                      item-text="name"
                      item-value="id"
                      prepend-icon="mdi-account-card-details"
                    >
                      <template slot="no-data">
                        <v-alert :value="true" color="error">
                          暂无驾驶员信息
                        </v-alert>
                      </template>
                      <template slot="item" slot-scope="props">
                        <v-list-tile-content>
                          <v-list-tile-title>
                            <v-flex row align-center justify-between>
                              <span>{{props.item.name}}</span>
                            </v-flex>
                          </v-list-tile-title>
                        </v-list-tile-content>
                        <v-list-tile-action>
                          <span class="grey--text caption text-xs-right">{{props.item.loginId}}</span>
                        </v-list-tile-action>
                      </template>
                    </v-autocomplete>
                  </v-flex>
                  <v-flex xs2 class="mt-3">
                    <v-btn flat color="primary" @click="addDriver">添加</v-btn>
                  </v-flex>
                </v-layout>
                <v-flex xs4 class="mb-2">
                  <v-btn flat color="primary" @click="extraInfo.showDrivers = !extraInfo.showDrivers">
                    <span v-if="!extraInfo.showDrivers">展示驾驶员列表</span>
                    <span v-else>隐藏驾驶员列表</span>
                  </v-btn>
                </v-flex>
                <l-data-table
                  v-if="extraInfo.showDrivers"
                  :headers="extraInfo.driverHeader"
                  :items="extraInfo.driverSelect"
                  hide-title>
                  <template slot="row-action" slot-scope="{item}">
                    <v-btn icon @click="deleteDriver(item)">
                      <v-icon>$vuetify.icons.delete</v-icon>
                    </v-btn>
                  </template>
                </l-data-table>
                <v-layout  class="mb-3">
                  <v-flex xs4 class="pl-2">
                    <v-autocomplete
                      :items="extraInfo.groupUserSelect"
                      v-model="extraInfo.admin"
                      v-on:keyup="getGroupUsers"
                      label="单位管理员配置"
                      clearable
                      hide-details
                      hide-selected
                      item-text="name"
                      item-value="id"
                      prepend-icon="mdi-account"
                    >
                      <template slot="no-data">
                        <v-alert :value="true" color="error">
                          暂无用户信息
                        </v-alert>
                      </template>
                      <template slot="item" slot-scope="props">
                        <v-list-tile-content>
                          <v-list-tile-title>
                            <v-flex row align-center justify-between>
                              <span>{{props.item.name}}</span>
                            </v-flex>
                          </v-list-tile-title>
                        </v-list-tile-content>
                        <v-list-tile-action>
                          <span class="grey--text caption text-xs-right">{{props.item.loginId}}</span>
                        </v-list-tile-action>
                      </template>
                    </v-autocomplete>
                  </v-flex>
                  <v-flex xs2 class="mt-3">
                    <v-btn flat color="primary" @click="addAdmin">添加</v-btn>
                  </v-flex>
                </v-layout>
                <v-flex xs4 class="mb-2">
                  <v-btn flat color="primary" @click="extraInfo.showAdmins = !extraInfo.showAdmins">
                    <span v-if="!extraInfo.showAdmins">展示管理员列表</span>
                    <span v-else>隐藏管理员列表</span>
                  </v-btn>
                </v-flex>
                <l-data-table
                  v-if="extraInfo.showAdmins"
                  :headers="extraInfo.adminHeader"
                  :items="extraInfo.adminSelect"
                  hide-title>
                  <template slot="row-action" slot-scope="{item}">
                    <v-btn icon @click="deleteAdmin(item)">
                      <v-icon>$vuetify.icons.delete</v-icon>
                    </v-btn>
                  </template>
                </l-data-table>
                <v-layout  class="mb-3">
                  <v-flex xs4 class="pl-2">
                    <l-plate-picker v-model="extraInfo.vehicle" label="单位公车配置"></l-plate-picker>
                  </v-flex>
                  <v-flex xs2 class="mt-3">
                    <v-btn flat color="primary" @click="addVehicle">添加</v-btn>
                  </v-flex>
                </v-layout>
                <v-flex xs4 class="mb-2">
                  <v-btn flat color="primary" @click="extraInfo.showVehicles = !extraInfo.showVehicles">
                    <span v-if="!extraInfo.showVehicles">展示单位公车列表</span>
                    <span v-else>隐藏单位公车列表</span>
                  </v-btn>
                </v-flex>
                <l-data-table
                  v-if="extraInfo.showVehicles"
                  :headers="extraInfo.vehicleHeader"
                  :items="extraInfo.vehiclSelect"
                  hide-title>
                  <template slot="row-action" slot-scope="{item}">
                    <v-btn icon @click="deleteVehicle(item)">
                      <v-icon>$vuetify.icons.delete</v-icon>
                    </v-btn>
                  </template>
                </l-data-table>
              </v-layout>
            </v-layout>
          </v-form>
        </v-card>
      </v-flex>
    </v-layout>
  </l-layout>
</template>
<script>
import LPlatePicker from '../../components/LPlatePicker'
export default {
  components: {
    LPlatePicker
  },
  data () {
    return {
      extraInfo: {
        driver: '',
        driverSelect: [],
        admin: [],
        adminSelect: [],
        vehicle: '',
        vehiclSelect: [],
        groupUserSelect: [],
        driverHeader: [
          {text: '驾驶员姓名', value: 'name', align: 'left', sortable: false},
          {text: '驾驶员ID', value: 'loginId', align: 'left'},
          {text: '', value: ''}
        ],
        adminHeader: [
          {text: '管理员姓名', value: 'name', align: 'left', sortable: false},
          {text: '管理员ID', value: 'loginId', align: 'left'},
          {text: '', value: ''}
        ],
        vehicleHeader: [
          {text: '车牌号', value: 'id', align: 'left'},
          {text: '', value: '', sortable: false}
        ],
        showDrivers: false,
        showAdmins: false,
        showVehicles: false
      },
      loading: false,
      searchSelects: [],
      ownerId: '',
      status: ''
    }
  },
  created () {
    this.status = this.$route.query.status
  },
  methods: {
    getExtraConfig () {
      this.getDrivers()
      this.getAdmins()
      this.getVehicles()
    },
    async getGroups (data) {
      let search = (data === undefined) ? '' : data.target.value
      let pagination = {page: 0, rowsPerPage: 10}
      let param = {
        'searchParam': {
          'name': {
            'index': '1',
            'order': 'DESC',
            'operators': [
              {
                'keyword': search,
                'operator': 'LIKE',
                'matchType': 'BOTH'
              }
            ]
          }
        }
      }
      let res = await this.$store.dispatch('reservationConfig/getGroups', {param: param, pagination: pagination})
      if (res.data.status === 1) {
        this.searchSelects = res.data.data.content
      }
      else {
        this.searchSelects = []
      }
    },
    async getGroupUsers (data) {
      let search = (data === undefined) ? '' : data.target.value
      let pagination = {page: 0, rowsPerPage: 10}
      let param = {
        'searchParam': {
          'name': {
            'index': '1',
            'order': 'DESC',
            'operators': [
              {
                'keyword': search,
                'operator': 'LIKE',
                'matchType': 'BOTH'
              }
            ]
          }
        }
      }
      let res = await this.$store.dispatch('reservationConfig/getGroupUsers', {param: param, pagination: pagination, id: this.ownerId})
      if (res.data.status === 1) {
        // alert(1)
        // console.log(res)
        this.extraInfo.groupUserSelect = res.data.data.content
      }
      else {
        this.extraInfo.groupUserSelect = []
      }
    },
    addDriver () {
      if (this.extraInfo.driver === '') {
        this.$L.alert('error', {message: '添加公车驾驶员不能为空'})
      }
      else {
        let ids = []
        // console.log(this.extraInfo.driverSelect)
        for (let n in this.extraInfo.driverSelect) {
          ids.push(this.extraInfo.driverSelect[n].id)
        }
        ids.push(this.extraInfo.driver)
        this.extraInfo.driver = ''
        this.updateDrivers(ids)
      }
    },
    async updateDrivers (ids) {
      let res = await this.$store.dispatch('vehicleRegister/addExtroConfig', {id: this.ownerId, type: 'driver', ids: ids})
      if (res.data.status === 1) {
        this.$L.alert('success', {message: '更新成功'})
        this.getDrivers()
      }
    },
    async getDrivers () {
      let res1 = await this.$store.dispatch('vehicleRegister/getExtroConfig', {id: this.ownerId, type: 'driver'})
      console.log(res1)
      if (res1.data.status === 1) {
        this.extraInfo.driverSelect = res1.data.data
      }
      else {
        this.$L.alert('error', {message: '获取驾驶员列表失败，原因：' + res1.data.msg})
      }
    },
    deleteDriver (item) {
      let index
      for (let i = 0; i < this.extraInfo.driverSelect.length; i++) {
        if (this.extraInfo.driverSelect[i].id === item.id) {
          index = i
          break
        }
      }
      this.extraInfo.driverSelect.splice(index, 1)
      let ids = []
      for (let n in this.extraInfo.driverSelect) {
        ids.push(n.id)
      }
      this.updateDrivers(ids)
    },
    addAdmin () {
      if (this.extraInfo.admin === '') {
        this.$L.alert('error', {message: '添加管理员不能为空'})
        return
      }
      let ids = []
      for (let n in this.extraInfo.adminSelect) {
        ids.push(this.extraInfo.adminSelect[n].id)
      }
      ids.push(this.extraInfo.admin)
      this.extraInfo.admin = ''
      this.updateAdmin(ids)
    },
    async updateAdmin (ids) {
      let res = await this.$store.dispatch('vehicleRegister/addExtroConfig', {id: this.ownerId, type: 'admin', ids: ids})
      if (res.data.status === 1) {
        this.$L.alert('success', {message: '更新成功'})
        this.getAdmins()
      }
    },
    async getAdmins () {
      let res1 = await this.$store.dispatch('vehicleRegister/getExtroConfig', {id: this.ownerId, type: 'admin'})
      if (res1.data.status === 1) {
        this.extraInfo.adminSelect = res1.data.data
      }
      else {
        this.$L.alert('error', {message: '获取驾驶员列表失败，原因：' + res1.data.msg})
      }
    },
    deleteAdmin (item) {
      let index
      for (let i = 0; i < this.extraInfo.driverSelect.length; i++) {
        if (this.extraInfo.adminSelect[i].id === item.id) {
          index = i
          break
        }
      }
      this.extraInfo.adminSelect.splice(index, 1)
      let ids = []
      for (let n in this.extraInfo.adminSelect) {
        ids.push(n.id)
      }
      this.updateAdmin(ids)
    },
    addVehicle () {
      if (this.extraInfo.vehicle === '') {
        this.$L.alert('error', {message: '添加公车不能为空'})
        return
      }
      let ids = []
      for (let n in this.extraInfo.vehiclSelect) {
        ids.push(this.extraInfo.vehiclSelect[n].id)
      }
      ids.push(this.extraInfo.vehicle)
      this.extraInfo.vehicle = ''
      this.updateVehicle(ids)
    },
    async updateVehicle (ids) {
      let res = await this.$store.dispatch('vehicleRegister/addExtroConfig', {id: this.ownerId, type: 'vehicle', ids: ids})
      if (res.data.status === 1) {
        this.$L.alert('success', {message: '更新成功'})
        this.getVehicles()
      }
    },
    async getVehicles () {
      let res1 = await this.$store.dispatch('vehicleRegister/getExtroConfig', {id: this.ownerId, type: 'vehicle'})
      console.log(res1)
      if (res1.data.status === 1) {
        this.extraInfo.vehiclSelect = []
        for (var i = 0; i < res1.data.data.length; i++) {
          var obj = {
            id: res1.data.data[i]
          }
          this.extraInfo.vehiclSelect.push(obj)
        }
      }
      else {
        this.$L.alert('error', {message: '获取驾驶员列表失败，原因：' + res1.data.msg})
      }
    },
    deleteVehicle (item) {
      let index
      for (let i = 0; i < this.extraInfo.vehiclSelect.length; i++) {
        if (this.extraInfo.vehiclSelect[i].id === item.id) {
          index = i
          break
        }
      }
      this.extraInfo.vehiclSelect.splice(index, 1)
      let ids = []
      for (let n in this.extraInfo.vehiclSelect) {
        ids.push(n.id)
      }
      this.updateVehicle(ids)
    },
  }
}
</script>
